import vTooltip from './tooltip'

export default {
    install(app) {
        app.directive('tooltip', vTooltip)
    }
}